<template>
  <van-grid :column-num="4" icon-size="40" :border="false">
    <van-grid-item
      v-for="(item, index) in navs"
      :key="index"
      :icon="item.picUrl"
      :text="item.text"
      :url="item.linkUrl"
    />
  </van-grid>
</template>

<script>
  import { subNavItems } from './config';

  export default {
    name: 'HomeSubNav',
    data() {
      return {
        navs: subNavItems,
      };
    },
  };
</script>

<style lang="scss" scoped>
.van-grid {
  .van-grid-item {
    ::v-deep .van-grid-item__content {
      background-color: transparent;
    }
  }
}
</style>
